import middleware from '@/commons/middleware';
import { ROUTER } from '@/constants';
import store from '@/stores/store';
import MainLayout from '../layouts/MainLayout.vue'

export default [
  {
    path: '/403',
    name: '403',
    component: () => import(/*webpackChunkName:'pages'*/ '@/pages/403.vue'),
    meta: {
      data: {},
      anonymous: true,
    },
  },
  {
    path: '/500',
    name: '500',
    component: () => import(/*webpackChunkName:'pages'*/ '@/pages/500.vue'),
    meta: {
      anonymous: true,
      data: {},
    },
  },
  {
    path: '/600/:id',
    name: '500',
    component: () =>
      import(
        /*webpackChunkName:'pages'*/ '@/components/common/upgrade/UpdateRequest.vue'
      ),
    meta: {
      data: {},
      key: ROUTER.PAGE_UPGRADE,
      pageName: 'Upgrade',
    },
    beforeEnter: middleware.validIdMiddleWare,
  },
  {
    path: '/700/:id',
    name: '600',
    component: () =>
      import(
        /*webpackChunkName:'pages'*/ '@/components/common/upgrade/UpdateRequest.vue'
      ),
    meta: {
      anonymous: true,
      data: {},
      key: ROUTER.PAGE_PURCHASE,
      pageName: 'Purchase Extra Devices',
    },
    beforeEnter: middleware.validIdMiddleWare,
  },
  {
    path: '/800/:id',
    name: '700',
    component: () =>
      import(
        /*webpackChunkName:'pages'*/ '@/components/common/upgrade/UpdateRequest.vue'
      ),
    meta: {
      anonymous: true,
      data: {},
      key: ROUTER.PAGE_EXTEND,
      pageName: 'Extend',
    },
    beforeEnter: middleware.validIdMiddleWare,
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/*webpackChunkName:'login'*/ '@/pages/Login.vue'),
    beforeEnter: (to, from, next) => {
      store.commit('context/removeToken');
      next();
    },
    meta: {
      data: {},
      anonymous: true,
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import(/*webpackChunkName:'logout'*/ '@/pages/Logout.vue'),
    meta: {
      data: {},
    },
  },
  {
    path: '/verify-two-factor',
    name: 'TwoFactor',
    component: () => import('@/pages/VerifyCodeTwoFactor.vue'),
    meta: {
      data: {},
      anonymous: true,
    },
  },
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '/settings',
        name: 'Settings',
        component: () => import('@/pages/Settings.vue'),
        meta: {
          data: {},
        },
      },
      {
        path: '/request-page',
        name: 'RequestPage',
        component: () => import('@/pages/RequestPage.vue'),
        meta: {
          data: {},
        },
      },
      {
        path: '/license-page',
        name: 'LicensePage',
        component: () => import('@/pages/LicensePage.vue'),
        meta: {
          data: {},
        },
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () =>
          import(/*webpackChunkName:'Dashboard'*/ '@/pages/Dashboard.vue'),
        meta: {
          data: {},
        },
      },
      {
        path: '/tickets',
        name: 'Tickets',
        component: () => import('@/pages/TicketsPage.vue'),
        meta: {
          data: {},
        },
      },
      /**lvduy 25.12.2024 Bố sung partner-page*/
      {
        path: '/partner-page',
        name: 'PartnerPage',
        component: () => import('@/pages/PartnerPage.vue'),
        meta: {
          data: {},
        },
      },
    ],
  },
  {
    path: '/license-upgrade/:id',
    name: 'LicenseUpgrade',
    component: () => import('@/components/common/upgrade/UpdateRequest.vue'),
    meta: {
      data: {},
      key: ROUTER.PAGE_UPGRADE,
      pageName: 'Upgrade',
    },
    beforeEnter: middleware.validIdMiddleWare,
  },
  {
    path: '/license-extend/:id',
    name: 'LicenseExtend',
    component: () => import('@/components/common/upgrade/UpdateRequest.vue'),
    meta: {
      data: {},
      key: ROUTER.PAGE_EXTEND,
      pageName: 'Extend',
    },
    beforeEnter: middleware.validIdMiddleWare,
  },
  {
    path: '/license-purchase/:id',
    name: 'LicensePurchase',
    component: () => import('@/components/common/upgrade/UpdateRequest.vue'),
    meta: {
      data: {},
      roles: null,
      key: ROUTER.PAGE_PURCHASE,
      pageName: 'Purchase Extra Devices',
    },
    beforeEnter: middleware.validIdMiddleWare,
  },
  {
    path: '/update-request',
    children: [
      {
        path: 'upgrade/:id',
        name: 'UpdateRequestUpgrade',
        component: () => import('@/components/common/upgrade/UpdateRequest.vue'),
        meta: {
          data: {},
          key: ROUTER.PAGE_UPGRADE,
          pageName: 'UpdateRequestUpgrade',
        },
        beforeEnter: middleware.validIdMiddleWareEditPage,
      },
      {
        path: 'extend/:id',
        name: 'UpdateRequestExtend',
        component: () => import('@/components/common/upgrade/UpdateRequest.vue'),
        meta: {
          data: {},
          key: ROUTER.PAGE_EXTEND,
          pageName: 'UpdateRequestUpgrade',
        },
        beforeEnter: middleware.validIdMiddleWareEditPage,
      },
      {
        path: 'purchase/:id',
        name: 'UpdateRequestPurchase',
        component: () => import('@/pages/UpdateRequest.vue'),
        meta: {
          data: {},
          roles: null,
          key: ROUTER.PAGE_PURCHASE,
          pageName: 'Purchase Extra Devices',
        },
        beforeEnter: middleware.validIdMiddleWareEditPage,
      },
    ],
  },
  {
    path: '/approve-request',
    children: [
      {
        path: 'upgrade/:id',
        name: 'RequestDetailUpgrade',
        component: () => import('@/components/common/upgrade/UpdateRequest.vue'),
        meta: {
          data: {},
          key: ROUTER.PAGE_UPGRADE,
          pageName: 'ApproveRequestUpgrade',
        },
        beforeEnter: middleware.validIdMiddleWareEditPage,
      },
      {
        path: 'extend/:id',
        name: 'RequestDetailExtend',
        component: () => import('@/components/common/upgrade/UpdateRequest.vue'),
        meta: {
          data: {},
          key: ROUTER.PAGE_EXTEND,
          pageName: 'ApproveRequestUpgrade',
        },
        beforeEnter: middleware.validIdMiddleWareEditPage,
      },
      {
        path: 'purchase/:id',
        name: 'RequestDetailPurchase',
        component: () => import('@/components/common/upgrade/UpdateRequest.vue'),
        meta: {
          data: {},
          roles: null,
          key: ROUTER.PAGE_PURCHASE,
          pageName: 'ApproveRequestUpgrade',
        },
        beforeEnter: middleware.validIdMiddleWareEditPage,
      },
    ],
  },
];
